module.exports = __webpack_public_path__ + "img/table-layout-sharp-thin.3655d7b2.svg";